"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../../helpers");
var helpers_2 = require("../PageWizardBody/helpers");
var StackView_1 = require("../../StackView");
var View_1 = require("../../View");
var WrapperContent = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Root = styled_components_1.default(StackView_1.StackView)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: ", ";\n    background-color: ", ";\n\n    ", "\n"], ["\n    height: ", ";\n    background-color: ", ";\n\n    ",
    "\n"])), helpers_1.SPACING_XXXL, function (_a) {
    var theme = _a.theme;
    return theme.colorHighlightNotification;
}, function (_a) {
    var fullWidthContent = _a.fullWidthContent, widthContent = _a.widthContent;
    if (fullWidthContent || widthContent === '100%') {
        return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                justify-content: center;\n            "], ["\n                justify-content: center;\n            "])));
    }
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            padding-right: ", ";\n            padding-left: ", ";\n\n            ", " {\n                width: ", ";\n            }\n        "], ["\n            padding-right: ", ";\n            padding-left: ", ";\n\n            ", " {\n                width: ", ";\n            }\n        "])), helpers_1.SPACING_M, helpers_2.config.paddingLeft, WrapperContent, widthContent);
});
exports.PageWizardFooter = function (_a) {
    var fullWidthContent = _a.fullWidthContent, widthContent = _a.widthContent, children = _a.children, rest = __rest(_a, ["fullWidthContent", "widthContent", "children"]);
    return (react_1.default.createElement(Root, __assign({}, rest, { testId: rest['data-selector-id'] || 'pagewizard-wizardfooter', root: true, align: StackView_1.STACK_ALIGN.center, fullWidthContent: fullWidthContent, widthContent: widthContent, spaceFill: fullWidthContent ? undefined : View_1.SPACE_FILL.all }),
        react_1.default.createElement(WrapperContent, null, children)));
};
exports.PageWizardFooter.displayName = 'PageWizardFooter';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=PageWizardFooter.js.map